import React, { useCallback } from 'react';
import { Button, Icon, Message } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import trimSize from '@/utils/stringsHelper';
import MarkdownRender from './MarkdownRender';

const TrimmedMarkdownRender = ({
  className,
  linkTarget,
  maxChars = 100000,
  maxLines = 0,
  withMessage,
  withShowMore,
  suffix = 'markdown.partial.suffix',
  text,
}) => {
  const intl = useIntl();
  const { trimmed, value } = trimSize(text, maxChars, maxLines, suffix ? intl.formatMessage({ id: suffix }) : null);
  const [isShowingMore, setIsShowingMore] = React.useState(false);

  const onToggle = useCallback(() => {
    setIsShowingMore((prevValue) => !prevValue);
  }, []);

  return (
    <div className="aridhia-trimmed-markdown-render">
      {trimmed && withMessage && (
        <Message
          warning
          size="small"
          icon="info circle"
          header={intl.formatMessage({ id: 'markdown.partial.title' })}
          content={intl.formatMessage({ id: 'markdown.partial.download' })}
        />
      )}
      <MarkdownRender
        value={withShowMore && isShowingMore ? text : value}
        className={className}
        linkTarget={linkTarget}
      />
      {withShowMore && trimmed && (
        <Button onClick={onToggle} size="tiny" circular icon>
          <Icon name={isShowingMore ? 'angle up' : 'angle down'} />
        </Button>
      )}
    </div>
  );
};

export default TrimmedMarkdownRender;
